<div class="card border-0 shadow-sm h-100">
    <div class="card-body d-flex flex-column">
        <div class="d-sm-flex justify-content-center align-items-center mb-4">
            <h4 class="mb-0 text-secondary">{{ title }}</h4>
        </div>
        <dx-pie-chart
            type="doughnut"
            [dataSource]="chartItems"
            [innerRadius]="0.7"
            centerTemplate="centerTemplate"
            [customizePoint]="customizePoint"
            sizeGroup="pies"
            (onInitialized)="onChartInitialized($event)"
        >
            <dxo-pie-chart-size [height]="260"></dxo-pie-chart-size>
            <dxi-series argumentField="argument" valueField="value">
                <dxo-label [visible]="false"></dxo-label>
            </dxi-series>
            <dxo-tooltip [enabled]="hasData" [customizeTooltip]="customizeTooltip" format="millions"></dxo-tooltip>
            <dxo-legend [visible]="false"></dxo-legend>
            <svg *dxTemplate="let pieChart of 'centerTemplate'">
                <text text-anchor="middle"
                      style="font-size: 32px; fill: currentColor; font-weight: 600;"
                      x="100" y="100">
                    <tspan x="100" dy="0">{{ centerLabel }}</tspan>
                    <tspan class="text-body-secondary"
                           x="100" dy="22"
                           style="font-size: 13px; fill: currentColor; font-weight: normal;">{{ centerText }}</tspan>
                </text>
            </svg>
        </dx-pie-chart>

        <div class="d-flex flex-wrap justify-content-center column-gap-3 row-gap-2 mt-3">
            @for (item of items; track item.argument) {
                <span class="d-inline-flex align-items-center"
                      style="cursor: pointer;"
                      [class.opacity-50]="hiddenArguments.has(item.argument)"
                      (click)="onLegendClick(item.argument)"
                      (mouseenter)="onLegendHover(item.argument, true)"
                      (mouseleave)="onLegendHover(item.argument, false)">
                    <span class="rounded-circle me-1 flex-shrink-0"
                          style="width: 14px; height: 14px;"
                          [style.background]="legendColor(item.argument)"></span>
                    <small class="text-body-secondary"
                           [class.text-decoration-line-through]="hiddenArguments.has(item.argument)">{{ legendLabel(item.argument) }}</small>
                </span>
            }
        </div>
    </div>
</div>
